import { Turnstile } from '@marsidev/react-turnstile';

const TurnstileWidget = ({ onVerify }) => {
  const handleSuccess = (token) => {
    console.log('Turnstile verification successful! Token:', token);
    onVerify(token);
  };

  const handleError = (error) => {
    console.error('Turnstile error:', error);
  };

  return (
    <div>
      <Turnstile
        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA'}
        onSuccess={handleSuccess}
        onError={handleError}
        options={{
          theme: 'light',
          size: 'normal',
          action: 'search',
          cData: 'candidate-search'
        }}
        scriptOptions={{
          appendTo: 'body'
        }}
      />
    </div>
  );
};

export default TurnstileWidget;
